import React, { useState, useMemo, useContext } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader, Button } from "reactstrap";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import { getUserById } from "../../Users/services/userApi";
import { getInspectionById } from "../../Inspection/services/inspectionsApi";
import VehIncident from "./vehIncident";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import IncidentItem from "./incidentItem";
import VehiclePosition from "../../Vehicules/component/vehiclePosition";
const DetailIncident = () => {

  const history = useContext(HistoryContext);
  const { id } = useParams();

  document.title = `Détails Incdents | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const { data: inspection = [], isLoading: isLoadingInsp, isError: isErrorInsp, error: errorInsp } = useQuery(
    ['inspection', id],
    () => getInspectionById(id)
  );
  console.log("inspection",inspection);

  const userId = inspection?.vehicle?.actualUserId;
  const { data: user = [], isLoading: isLoadingUser } = useQuery(
    ['user', userId],
    () => getUserById(userId),
    { enabled: !!userId }
  );
 

return (
  <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <BreadCrumb page="Détail incidents" history={history} />
        <Card>
          <Row>
            <Col lg={12}>
            <VehIncident user={user} vehicle={inspection?.vehicle}/>
            </Col>
            <Col lg={8}>
                <IncidentItem inspection={inspection} isLoading={isLoadingInsp} isError={isErrorInsp} error={errorInsp}/>
              </Col>
              <Col lg={4}>
              <VehiclePosition user={user}/>
              </Col>
          </Row>
        </Card>
      </Container>
    </div>
  </React.Fragment>
);
  
};


export default DetailIncident;
